var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverallTimeChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7273 20.7273H3.27273V18.5455H4.36364V19.6364H19.6364V4.36364H18.5455V3.27273H20.7273V20.7273ZM21.8182 6.54545V7.63636H22.9091V22.9091H7.63636V21.8182H6.54545V24H24V6.54545H21.8182ZM0 0V17.4545H17.4545V0H0ZM5.45455 16.3636H1.09091V12H5.45455V16.3636ZM5.45455 10.9091H1.09091V6.54545H5.45455V10.9091ZM5.45455 5.45455H1.09091V1.09091H5.45455V5.45455ZM10.9091 16.3636H6.54545V12H10.9091V16.3636ZM10.9091 10.9091H6.54545V6.54545H10.9091V10.9091ZM10.9091 5.45455H6.54545V1.09091H10.9091V5.45455ZM16.3636 16.3636H12V12H16.3636V16.3636ZM16.3636 10.9091H12V6.54545H16.3636V10.9091ZM16.3636 5.45455H12V1.09091H16.3636V5.45455Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M5.45446 5.45446H1.09082V1.09082H5.45446V5.45446ZM11.9999 10.909H16.3635V6.54537H11.9999V10.909ZM6.54537 11.9999V16.3635H10.909V11.9999H6.54537Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.54537 5.45446V1.09082H10.909V5.45446H6.54537ZM5.45446 11.9999H1.09082V16.3635H5.45446V11.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallTimeChart);
export default __webpack_public_path__ + "static/media/overallTimeChart.62a919d70cc9e0d961c77654bedc9846.svg";
export { ForwardRef as ReactComponent };